import React, { useState, useEffect } from 'react'
import BasicPagination from '../Pagination';
import CommanInput from '../Constent/CommanInput';
import CommanDropDown from '../Constent/CommanDropDown';
import { Button } from 'react-bootstrap';
import { DELETS_WITH_TOKEN, GET_WITH_TOKEN, Post_WITH_TOKEN } from '../../Backend/Bakend';
import { showToast } from '../Constent/Toast';

const PackageCategories = () => {
    const [bookingData, setBookingData] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [image, setImage] = useState('');
    const [search, setSearch] = useState('');
    const [CurrentPage, setCurrentPage] = useState(1);
    const [IsEdit, setIsEdit] = useState(false);
    const [IsEditId, setIsEditId] = useState('');
    const [categoriesData, setcategoriesData] = useState([])
    const [errors, setErrors] = useState({});

    const [Data, setData] = useState({
        name: "",
        slug: "",
        description: "",
        main_category_id: ""
    })

    useEffect(() => {
        getPostShow(1);
        GetCat()
    }, [])

    // Validation function
    const validateForm = (formData) => {
        const newErrors = {};
        
        // Required fields validation
        if (!formData.name || formData.name.trim() === '') {
            newErrors.name = 'Name is required';
        }
        if (!formData.slug || formData.slug.trim() === '') {
            newErrors.slug = 'Slug is required';
        }
        if (!formData.description || formData.description.trim() === '') {
            newErrors.description = 'Description is required';
        }
        
        setErrors(newErrors);
        return newErrors;
    };


    const GetCat = () => {
        GET_WITH_TOKEN("/api/package-categories", "", e => {
            // setBaseList(e.data);
            console.log(e, "eeeeee")
            // showToast("success")
            setcategoriesData(e.data)
        }, f => {
            showToast(f.message || f.msg)
        }, n => {
            showToast(n.message || n.msg || "Somthing Wants to rong")
        })
    }


    const ShowById = (id) => {
        GET_WITH_TOKEN(`/api/package-categories/${id}`, "", success => {
            console.log('Success:', success);
            if (!!success) {
                setData(success)
            }
        }, error => {
            console.log(error)
        }, fail => { console.log(fail) })
    };

    const getPostShow = (page) => {
        setBookingData([])
        const searchParam = search?.trim() ? `&search=${search.trim()}` : '';
        GET_WITH_TOKEN(`/api/package-categories?page=${page}${searchParam}`, "", success => {
            console.log('Success:', success);
            if (!!success?.data) {
                setBookingData(success.data.data);
                setTotalPage(success.data.last_page);
                setCurrentPage(success.data.current_page);
            }
        }, error => {
            console.log(error)
        }, fail => { console.log(fail) })
    };
    const deletePost = (page) => {
        DELETS_WITH_TOKEN(`/api/package-categories/${page}`, "", success => {
            console.log('Success:', success);
            if (!!success) {
                showToast(success?.message || success?.msg || "package-categories delete ")
                getPostShow(1);
            }
        }, error => {
            console.log(error)
        }, fail => { console.log(fail) })
    };


    const StatusData = [
        { id: 1, name: "Active", value: 1 }, { id: 0, name: "InActive", value: 0 }
    ]


    const onChange = (e, name) => {
        setData({ ...Data, [name]: e })
    }



    const handleSubmit = () => {
        // Validate form before submission
        const validationErrors = validateForm(Data);
        if (Object.keys(validationErrors).length > 0) {
            // Don't show toast message, let user see individual field errors
            return;
        }

        const formdata = new FormData();
        formdata.append("name", Data?.name);
        formdata.append("slug", Data?.slug);
        formdata.append("description", Data?.description);
        formdata.append("main_category_id", Data?.main_category_id);
        IsEdit && formdata.append('_method', "PUT")
        Post_WITH_TOKEN(IsEdit ? `/api/package-categories/${IsEditId}` : '/api/package-categories', formdata, success => {
            console.log(success);
            showToast(IsEdit ? "Package Category updated successfully!" : "Package Category created successfully!");
            getPostShow(1);
            // Reset form after successful submission
            setIsEdit(false);
            setIsEditId('');
            setData({
                name: "",
                slug: "",
                description: "",
                main_category_id: ""
            });
            setErrors({});
            // Close modal after successful submission
            const modalElement = document.querySelector('#offcanvasRight');
            if (modalElement) {
                // Use Bootstrap's data attribute to close modal
                modalElement.setAttribute('data-bs-dismiss', 'offcanvas');
                const closeButton = modalElement.querySelector('.btn-close');
                if (closeButton) {
                    closeButton.click();
                }
            }
        }, error => {
            console.log(error);
            showToast("Error: " + (error?.message || error || "Something went wrong"));
        }, fail => {
            console.log(fail);
            showToast("Error: " + (fail?.message || fail || "Something went wrong"));
        })
    }

    return (
        <div>
            <div className='container mt-1'>
                <div className='row'>
                    <div className='col-lg-12  '>

                        <div className='card'>
                            <div className='card-header'>

                                <p style={{ fontSize: '25px' }}>Package Categories</p>

                                <div class="mb-3  mt-4 d-flex">
                                    <input type="text" class="form-control " id="exampleFormControlInput1"
                                        placeholder="Enter Name" style={{ width: '20%' }} onChange={(e) => { setSearch(e.target.value) }} />

                                    <button onClick={() => { getPostShow(CurrentPage) }} type='btn' className='ms-4' style={{ backgroundColor: '#008c93', color: '#fff', border: 'none', padding: '7px 15px', borderRadius: '8px' }}>Search</button>

                                    <button type='btn' className='ms-2' style={{ backgroundColor: 'transparent', color: '#000', padding: '7px 15px', borderRadius: '8px', border: '1px solid gray' }}>Reset</button>


                                    <button onClick={() => { 
                                        setIsEdit(false);
                                        setIsEditId('');
                                        setData({
                                            name: "",
                                            slug: "",
                                            description: "",
                                            main_category_id: ""
                                        });
                                        setErrors({});
                                    }} type='btn' className='ms-2' data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style={{ backgroundColor: '#366fe9', color: '#000', padding: '7px 15px', borderRadius: '8px', border: '1px solid gray' }}>Add New</button>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div className='card-body' style={{ height: 550, overflowY: "scroll" }}>
                                <p style={{ fontSize: '20px' }}>View All Package Categories</p>

                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">id</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">slug</th>
                                            <th scope="col">description</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {

                                            bookingData?.length > 0 ?
                                                bookingData?.map((res, index) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <th scope="row">{index + 1}</th>
                                                                <td>{res?.name}</td>
                                                                <td>{res?.slug}</td>
                                                                <td>{res?.description}</td>
                                                                <td>
                                                                    <div >
                                                                        <button className='py-2 mx-2' style={{
                                                                            backgroundColor: '#3cc3b0', color: '#fff',
                                                                            border: 'none', borderRadius: '4px'
                                                                        }} onClick={() => { ShowById(res?.id); setIsEdit(true); setIsEditId(res?.id); setErrors({}); }} data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Edit</button>
                                                                        <button onClick={() => {
                                                                            deletePost(res?.id)
                                                                        }} className='py-2' style={{
                                                                            backgroundColor: '#9ba322', color: '#fff',
                                                                            border: 'none', borderRadius: '4px'
                                                                        }}>Delete</button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                }) : null
                                        }



                                    </tbody>

                                </table>
                                {
                                    bookingData?.length > 0 ? null :
                                        <div className="data-not-found">
                                            <h2 className="bounce">Data Not Found</h2>
                                            <p className="fade-in">Sorry, the requested data could not be found.</p>
                                        </div>
                                }
                            </div>
                            <div style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                <BasicPagination count={totalPage} onChange={(e) => { getPostShow(e) }} />
                            </div>
                        </div>



                    </div>
                </div>
            </div>

            <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel" data-bs-keyboard="false" style={{ width: '50%' }}>
                <div class="offcanvas-header">
                    <h5 id="offcanvasRightLabel">Add Package Categories</h5>
                    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>

                <div className='offcanvas-body'>
                    <CommanInput value={Data?.name} placeholder={"Name"} type='text' describtionShow={true} desTitle={"Name"} onChange={(e) => { console.log(e, "data"); setData({ ...Data, name: e }) }} />
                    {errors.name && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.name}</div>}

                    <CommanInput value={Data?.slug} placeholder={"Slug"} type='text' describtionShow={true} desTitle={"Slug"} onChange={(e) => { console.log(e, "data"); setData({ ...Data, slug: e }) }} />
                    {errors.slug && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.slug}</div>}

                    <CommanInput value={Data?.description} title={"Enter Description"} placeholder={"Enter Description"} type="text" describtionShow={true} input={false} textArea={true}desTitle={"Enter Description"} onChange={(e) => {console.log(e, "data");onChange(e, "data"); setData({ ...Data, description: e })}} style={{ height: 160 }}/>
                    {errors.description && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.description}</div>}

                    <Button className='mt-3' onClick={() => { handleSubmit() }}>Submit</Button>
                </div>
            </div>
        </div>
    )
}

export default PackageCategories